import * as Sentry from '@sentry/browser';
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    dsn: String,
    enabled: Boolean,
    environment: String,
    release: String,
  };

  connect() {
    const sentryConfiguration = {
      dsn: this.dsnValue,
      environment: this.environmentValue,
      release: this.releaseValue,
      ignoreErrors: [/AbortError/],
    };

    if (this.enabledValue) {
      Sentry.init(sentryConfiguration);
    } else {
      console.log('Sentry is disabled', sentryConfiguration);
    }
  }
}
